import React from 'react';
import EmployersHero from '../components/EmployersHero';
import RecruitingAdvantage from '../components/RecruitingAdvantage';
import WhyEmployers from '../components/WhyEmployers';
import CompanyTestimonials from '../components/CompanyTestimonials';
import FAQ from '../components/FAQ';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';

const Employers: React.FC = () => {
    return (
        <>
            <EmployersHero />

            <FadeInSection delay={0.2}>
                <RecruitingAdvantage />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <WhyEmployers />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <CompanyTestimonials />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <FAQ
                    candidateFaqs={[]}
                    employerFaqs={[
                        { q: "How does David find us top candidates?", a: "David, our AI recruiter, learns exactly what you're looking for by analyzing your job description and a short intake conversation after you upload it. From there, he presents carefully matched candidates. As you provide feedback—positive or negative—David continuously refines his algorithm to deliver even stronger matches over time." },
                        { q: "How quickly can we expect to see candidates?", a: "We share your first set of profiles 24-48 hours after uploading a role - following that we share new batches of candidates every Tuesday." },
                        { q: "Can Hush integrate with our existing hiring tools?", a: "Yes! Hush integrates seamlessly with your existing ATS and workflows, so candidate profiles, scheduling, and communications stay centralized." },
                        { q: "How does Hush ensure diversity in hiring?", a: "David is designed to remove bias from sourcing and matching by focusing on skills, experience, and preferences. Our vetting process ensures diverse, qualified candidates are included in every search." },
                        { q: "How much does Hush cost?", a: "We charge based on qualified candidates, reach out to someone on our sales team (founders@hushtalent.io) to learn more!" }
                    ]}
                />
            </FadeInSection>

            <FadeInSection delay={0.2}>
                <CallToAction />
            </FadeInSection>

            <Footer />
        </>
    );
};

export default Employers;
